/* tslint:disable */
/* eslint-disable */
/**
 * Common
 * 共通API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShippingTime } from './ShippingTime';
import {
    ShippingTimeFromJSON,
    ShippingTimeFromJSONTyped,
    ShippingTimeToJSON,
} from './ShippingTime';

/**
 * 
 * @export
 * @interface GetShippingTimes200ResponseAllOfData
 */
export interface GetShippingTimes200ResponseAllOfData {
    /**
     * 
     * @type {Array<ShippingTime>}
     * @memberof GetShippingTimes200ResponseAllOfData
     */
    shippingTimes: Array<ShippingTime>;
}

/**
 * Check if a given object implements the GetShippingTimes200ResponseAllOfData interface.
 */
export function instanceOfGetShippingTimes200ResponseAllOfData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "shippingTimes" in value;

    return isInstance;
}

export function GetShippingTimes200ResponseAllOfDataFromJSON(json: any): GetShippingTimes200ResponseAllOfData {
    return GetShippingTimes200ResponseAllOfDataFromJSONTyped(json, false);
}

export function GetShippingTimes200ResponseAllOfDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetShippingTimes200ResponseAllOfData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shippingTimes': ((json['shipping_times'] as Array<any>).map(ShippingTimeFromJSON)),
    };
}

export function GetShippingTimes200ResponseAllOfDataToJSON(value?: GetShippingTimes200ResponseAllOfData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shipping_times': ((value.shippingTimes as Array<any>).map(ShippingTimeToJSON)),
    };
}

